export { ResumenCargaDescarga } from "app/features/componentes/cargas";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/edit/estatus/items/resumen/comp.tsx